import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
//import TvModal from "./modals/TvModal";
import WhiteHeader from "./WhiteHeader";
import DefaultHeader from "./DefaultHeader";
import { mobileMatchMedia, largeScreenMatchMedia } from "../../util";
import { connect } from "react-redux";
import { resetConnection } from "../../store/actions/connection";
import {
  setAvailabilityModal,
  focusUnit,
  getEmergencyStatus,
  setPageRequestFibrestream,
  setPreviousPathname,
} from "../../store/actions/app";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileMenuSwitch: false,
      open: false,
      activeModal: false,
      // tvVisible: false,
      prevPathname: null,
    };
    this.isModalClose = false;
    this.toggleContainer = React.createRef();

    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.getMenu = this.getMenu.bind(this);
    this.getSignupMenu = this.getSignupMenu.bind(this);

    this.openModal = this.openModal.bind(this);
    this.onInternetClick = this.onInternetClick.bind(this);
    this.smoothScroll = this.smoothScroll.bind(this);
    this.onClickOutsideHandler = this.onClickOutsideHandler.bind(this);
    this.onSigninClick = this.onSigninClick.bind(this);
    this.openCheckAvailabilityModal = this.openCheckAvailabilityModal.bind(
      this
    );
    this.closeAvailabilityModal = this.closeAvailabilityModal.bind(this);
    this.focusUnitCode = this.focusUnitCode.bind(this);
    this.measureHeight = this.measureHeight.bind(this);
    this.checkScreenSize = this.checkScreenSize.bind(this);
    this.scrollToInternet = this.scrollToInternet.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  resetHeader() {
    const stickyHeader = document.querySelector(".sticky-header-container");
    const topSection = document.querySelector(".top-section");
    const spaceSection = document.querySelector("section.space");
    stickyHeader.style.top = 0;
    if (topSection) {
      topSection.style.marginTop = 0;
    }
    if (spaceSection) {
      spaceSection.style.marginTop = 0;
    }

    if (document.querySelector(".sticky-logo-container div:last-child")) {
      const stickyLogoDiv = document.querySelector(
        ".sticky-logo-container div:last-child"
      );
      stickyLogoDiv.style.top = 0;
    }
  }

  measureHeight() {
    if (document.querySelector(".notification")) {
      const stickyHeader = document.querySelector(".sticky-header-container");
      const notificationDiv = document.querySelector(".notification");
      const topSection = document.querySelector(".top-section");
      const spaceSection = document.querySelector("section.space");
      const stickyHeaderHeight = stickyHeader.offsetHeight;
      const notificationDivHeight = notificationDiv.offsetHeight;
      if (!mobileMatchMedia()) {
        stickyHeader.style.top = notificationDivHeight + "px";
        if (topSection) {
          topSection.style.marginTop = stickyHeaderHeight + "px";
        }
        if (spaceSection) {
          spaceSection.style.marginTop = notificationDivHeight + "px";
        }
      } else {
        this.resetHeader();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.path !== this.props.match.path) {
      this.checkScreenSize();
    }

    if (this.props.emergencyMessage) {
      this.measureHeight();
    }
    if (
      prevProps.match.path !== this.props.match.path &&
      (this.props.match.path === "/internet" ||
        this.props.match.path === "/packages")
    ) {
      setTimeout(() => {
        this.scrollToInternet();
      }, 200);
    }

    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.props.setPreviousPathname(this.props.location.pathname);
    }

    if (
      prevProps.match.path !== this.props.match.path &&
      this.props.match.path === "/check"
    ) {
      this.openCheckAvailabilityModal();
    }
  }
  componentDidMount() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);

    let speedSection = document.querySelector("#speed_section");
    if (
      this.props.match.path === "/internet" ||
      this.props.match.path === "/packages"
    ) {
      let originalScreenWidth = window.outerWidth;
      setTimeout(() => {
        window.scrollTo(
          0,
          speedSection.offsetTop * (originalScreenWidth >= 1920 ? 1.25 : 1) - 60
        );
      }, 200);
    }

    if (this.props.history.location.search === "?from=check-availability") {
      setTimeout(() => {
        this.props.history.push("/");
      }, 500);

      this.openCheckAvailabilityModal();
    }

    if (this.props.match.path === "/check") {
      this.openCheckAvailabilityModal();
    }

    window.addEventListener("click", this.onClickOutsideHandler);
    window.addEventListener("scroll", this.onClickOutsideHandler);
    this.props.getEmergencyStatus();
  }

  checkScreenSize() {
    let originalScreenWidth = window.outerWidth;
    if (
      this.props.location.pathname !== "/locations" &&
      originalScreenWidth >= 1920
    ) {
      document.querySelector("body").style.zoom = "125%";
      document.querySelector("body").classList.add("is-zoom");
    } else {
      document.querySelector("body").style.zoom = null;
      document.querySelector("body").classList.remove("is-zoom");
    }
  }

  onSigninClick(e) {
    if (mobileMatchMedia) {
      setTimeout(() => {
        this.setState({
          mobileMenuSwitch: false,
        });
      }, 100);
      e.stopPropagation();
    }
  }

  onClickOutsideHandler(e) {
    if (
      this.toggleMobileMenu &&
      e.target instanceof Node &&
      !this.toggleContainer.current.contains(e.target)
    ) {
      this.setState({
        mobileMenuSwitch: false,
      });
    }
    if (
      mobileMatchMedia() &&
      document.querySelector(".sticky-logo-container")
    ) {
      if (this.state.mobileMenuSwitch === false && window.pageYOffset < 85) {
        document.querySelector(".sticky-logo-container").style.zIndex = 999;
      }
    }
    let stickyLogoContainer = document.querySelector(".sticky-logo-container");
    if (
      this.state.mobileMenuSwitch === false &&
      window.pageYOffset < 85 &&
      stickyLogoContainer
    ) {
      stickyLogoContainer.style.zIndex = 999;
    }
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onClickOutsideHandler);
    window.removeEventListener("scroll", this.onClickOutsideHandler);
    window.removeEventListener("resize", this.checkScreenSize);
  }

  openCheckAvailabilityModal() {
    var offset = document.body.scrollTop;
    document.body.style.top = offset * -1 + "px";
    document.body.classList.add("modal--opened");
    this.props.history.push("/check");
  }

  toggleMobileMenu(event) {
    event.preventDefault();
    this.setState({
      mobileMenuSwitch: !this.state.mobileMenuSwitch,
    });

    if (document.querySelector(".sticky-logo-container")) {
      if (this.state.mobileMenuSwitch === false && window.pageYOffset < 85) {
        document.querySelector(".sticky-logo-container").style.zIndex = 9;
      } else {
        document.querySelector(".sticky-logo-container").style.zIndex = 999;
      }
    }
  }

  openModal(modalName) {
    this.setState({
      activeModal: modalName,
      // tvVisible: (modalName === 'tv')
    });
  }

  smoothScroll(top, h) {
    let i = h;
    if (i < top) {
      setTimeout(() => {
        window.scrollTo(window.pageYOffset, i);
        if (top - i > 300) {
          this.smoothScroll(top, i + 300);
        } else {
          this.smoothScroll(top, i + 20);
        }
      }, 5);
    }
  }

  scrollToTop(h, top) {
    let i = h;
    if (i > top) {
      setTimeout(() => {
        window.scrollTo(window.pageYOffset, i);
        if (i - top > 100) {
          this.scrollToTop(i - 200, top);
        } else {
          this.scrollToTop(i - 10, top);
        }
      }, 5);
    }
  }

  scrollToInternet() {
    let speedSection = document.querySelector("#speed_section");
    let scrollFromTop = window.pageYOffset;

    if (speedSection === null) {
      return;
    }

    let speedSectionOffsetTop = largeScreenMatchMedia()
      ? speedSection.offsetTop * 1.25
      : speedSection.offsetTop;

    if (scrollFromTop > speedSectionOffsetTop - 60) {
      this.scrollToTop(scrollFromTop, speedSectionOffsetTop - 60);
    } else {
      this.smoothScroll(speedSectionOffsetTop - 60, window.pageYOffset);
    }
  }

  onInternetClick() {
    if (this.props.location.pathname === "/internet") {
      setTimeout(() => {
        this.scrollToInternet();
      });
    } else {
      this.props.history.push("/internet");
    }
  }

  getMenu() {
    return (
      <div
        className={
          this.state.mobileMenuSwitch ? "ui text menu vertical" : "ui text menu"
        }
        onClick={this.state.mobileMenuSwitch ? this.toggleMobileMenu : null}
      >
        {/* <Link className="item" to="/internet">Internet</Link> */}
        <a onClick={this.onInternetClick} className="item">
          Internet
        </a>
        {/* <a className="item" onClick={() => this.openModal('tv')}>TV</a> */}
        <div className="right menu">
          <Link className="item" to={"/support"}>
            Support
          </Link>
          {/*<a
            href="https://my.freshbooks.com"
            target="_blank"
            rel="noopener noreferrer"
            className="item"
            onClick={this.onSigninClick}
          >
            Sign In
          </a>*/}
        </div>
      </div>
    );
  }

  getLogo() {
    return (
      <h2 className="no-decoration text-prime itc-mdbold mb-0 default-logo">
        <Link to={"/"}>
          Fibre<span className=" itc-std-md text-stream">Stream</span>
        </Link>
      </h2>
    );
  }

  getMenuWithLogo() {
    return (
      <Fragment>
        <div className="three wide column pr-0">{this.getLogo()}</div>
        <div className="eleven wide column pr-0">{this.getMenu()}</div>
      </Fragment>
    );
  }

  getMenuWithoutLogo() {
    return <div className="fourteen wide column pr-0">{this.getMenu()}</div>;
  }

  getSignupMenu() {
    if (this.props.match.path === "/promotion/:code") {
      return (
        <a onClick={this.focusUnitCode} className="ui item btn--signup ml-0">
          Sign Up
        </a>
      );
    } else {
      return (
        <a
          onClick={this.openCheckAvailabilityModal}
          className="ui item btn--signup ml-0"
        >
          Sign Up
        </a>
      );
    }
  }

  closeAvailabilityModal(e) {
    const {
      history,
      setAvailabilityModal,
      openAvailabilityModal,
      isPageRequestFibreStream,
      setPageRequestFibrestream,
    } = this.props;

    setTimeout(() => {
      if (
        history.location.pathname === "/check" &&
        this.props.prevPathname !== null
      ) {
        setAvailabilityModal(false);
        history.push(this.props.prevPathname);
      } else if (
        history.location.pathname === "/check" &&
        this.props.prevPathname === null
      ) {
        setAvailabilityModal(false);
        history.push("/");
      } else if (openAvailabilityModal) {
        setAvailabilityModal(false);
      }
    });

    if (isPageRequestFibreStream) {
      setPageRequestFibrestream(false);
    }
  }

  focusUnitCode() {
    this.props.focusUnit();
  }

  render() {
    const { stickyContext, headerType, inverted } = this.props;
    return (
      <Fragment>
        {headerType === "white" ? (
          <WhiteHeader
            toggleContainer={this.toggleContainer}
            inverted={inverted}
            stickyContext={stickyContext}
            toggleMobileMenu={this.toggleMobileMenu}
            mobileMenuSwitch={this.state.mobileMenuSwitch}
            getMenu={this.getMenu}
            getSignupMenu={this.getSignupMenu}
            getLogo={this.getLogo}
            measureHeight={this.resetHeader}
          />
        ) : (
          <DefaultHeader
            toggleContainer={this.toggleContainer}
            stickyContext={stickyContext}
            toggleMobileMenu={this.toggleMobileMenu}
            mobileMenuSwitch={this.state.mobileMenuSwitch}
            getMenu={this.getMenu}
            getSignupMenu={this.getSignupMenu}
            getLogo={this.getLogo}
            measureHeight={this.resetHeader}
          />
        )}

        {/* <TvModal open={activeModal === 'tv'} visible={tvVisible} closeModal={this.closeModal} /> */}
        {/* {openAvailabilityModal && (
          <CheckAvailabilityModal
            open={openAvailabilityModal}
            closeModal={this.closeAvailabilityModal}
          />
        )} */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    address: state.connection.address,
    openAvailabilityModal: state.app.openAvailabilityModal,
    emergencyMessage: state.app.emergencyMessage,
    isPageRequestFibreStream: state.app.isPageRequestFibreStream,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetConnection: () => dispatch(resetConnection()),
    setAvailabilityModal: (flag) => dispatch(setAvailabilityModal(flag)),
    focusUnit: () => dispatch(focusUnit()),
    getEmergencyStatus: () => dispatch(getEmergencyStatus()),
    setPageRequestFibrestream: (flag) =>
      dispatch(setPageRequestFibrestream(flag)),
    setPreviousPathname: (payload) => dispatch(setPreviousPathname(payload)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Header)
);



// WEBPACK FOOTER //
// ./src/components/header/Header.js